import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { ROUTES } from '../../constants/routes';
import { generateUrl } from '../../routes/util';
import { Bank } from '../../types/banking-settings';
import { EditOptionProps } from '../../types/initiative';
import SimpleTooltip from '../simple-tooltip';

const displayBanks = (bankingSettings: Bank[]) => {
  return bankingSettings.map((bank) => bank.name).join(', ');
};

export const BankingSettingsRow = ({ label, initiative }: EditOptionProps) => {
  const history = useHistory();
  const { bankingSettings = [] } = initiative;

  const goToBankSettings = (e: React.MouseEvent) => {
    history.push(generateUrl(ROUTES.BANKING_SETTINGS, { initiativeId: initiative._id }));
  };

  return (
    <Row className='ml-0 mb-3 mr-0 text-row__wrapper'>
      <Col className={'col-md-4 col-12 align-self-start text-label-uppercase'}>{label}</Col>
      <Col className='col-md-6 col-10 text-right text-ellipsis__paragraph'>
        {bankingSettings.length ? (
          <SimpleTooltip text={displayBanks(bankingSettings)}>
            <span>{displayBanks(bankingSettings)}</span>
          </SimpleTooltip>
        ) : (
          <span className='text-ThemeTextPlaceholder'>not set</span>
        )}
      </Col>
      <Col className='col-2 d-flex align-self-end'>
        <Button color='link' onClick={goToBankSettings}>
          Edit
        </Button>
      </Col>
    </Row>
  );
};
